// extracted by mini-css-extract-plugin
export default {"move-back":"NavigationArrows_move-back__vm244","move-forward":"NavigationArrows_move-forward__yUxAY"};